
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.166 10.751L6.871 6.064a1.345 1.345 0 00-1.403.227c-.39.337-.553.857-.425 1.356l.838 3.287a.1.1 0 00.084.075l6.781.892c.116.015.116.183 0 .198l-6.781.892a.1.1 0 00-.084.075l-.838 3.287c-.128.5.035 1.019.425 1.356.39.338.928.424 1.403.227l11.295-4.687c.514-.214.834-.692.834-1.25a1.33 1.33 0 00-.834-1.248z"}})])
          )
        }
      }
    